<template>
  <VList searchable :meta="meta">
    <template #before>
      <VListHeader />
    </template>

    <template v-if="isLoading" #default>
      <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
        <Loader />
      </div>
    </template>

    <template v-else-if="isRejected" #default>
      <div class="odd:bg-red-100 border border-red-200 rounded p-4 text-red-600 text-center">
        Something went wrong. Please try again later.
      </div>
    </template>

    <template v-else-if="users.length" #default>
      <template v-for="user in users">
        <VListLine :key="`users_${user.id}`" :user="user" :disabled="isLoading" />
      </template>
    </template>

    <template v-else #default>
      <div class="odd:bg-gray-100 border border-gray-200 rounded p-4 text-center">
        No results found
      </div>
    </template>
  </VList>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import VList from '@/components/Common/VList.vue';
import VListHeader from '@/components/Users/VListHeader.vue';
import VListLine from '@/components/Users/VListLine.vue';

const STATUS_IDLE = 'idle';
const STATUS_PENDING = 'pending';
const STATUS_RESOLVED = 'resolved';
const STATUS_REJECTED = 'rejected';

export default {
  name: 'UserList',

  components: {
    VList,
    VListHeader,
    VListLine,
  },

  data: () => ({
    status: STATUS_IDLE,
  }),

  computed: {
    ...mapState('admin/users', ['meta']),
    ...mapGetters('admin/users', ['users']),
    isLoading() {
      return this.status === STATUS_PENDING;
    },
    isResolved() {
      return this.status === STATUS_RESOLVED;
    },
    isRejected() {
      return this.status === STATUS_REJECTED;
    },
  },

  watch: {
    $route: 'fetchData',
  },

  created() {
    this.fetchData();
  },

  destroyed() {
    this.setIds([]);
    this.setMeta(null);
    this.setLinks(null);
  },

  methods: {
    ...mapActions('admin/users', {
      loadUsers: 'getUsers',
    }),

    ...mapMutations('admin/users', ['setIds', 'setMeta', 'setLinks']),

    async fetchData() {
      const {
        query: { filter = {}, ...restQuery },
      } = this.$route;

      this.status = STATUS_PENDING;

      try {
        await this.loadUsers({
          queryParams: {
            filter: {
              ...filter,
            },
            ...restQuery,
          },
        });

        this.status = STATUS_RESOLVED;
      } catch (error) {
        this.status = STATUS_REJECTED;
      }
    },
  },
};
</script>
